import { MATERIAL, MODEL_ID } from 'Pods/ThreeDStudio/Store/constants'

const PROVIDER_KEY = 'tencent_hunyuan'

/**
 * Inverse of parseTencentTextTo3dProData. Builds an openedModel-shaped payload
 * from the current modelSettings so the just-submitted run can be reopened
 * without an extra API round-trip.
 *
 * @param {Object} state - ThreeDStudio store state (getState())
 * @param {string|number} id - Run id from the generation API response
 * @returns {Object} - openedModel payload accepted by parseTencentTextTo3dProData
 */
export const buildTencentTextTo3dProFromState = (state, id) => {
  const { modelSettings } = state
  const {
    prompt,
    material,
    targetPolycount,
    polygonType,
    isPrivate,
    selectedUseCase,
  } = modelSettings || {}

  return {
    id,
    providerKey: PROVIDER_KEY,
    providerModelId: MODEL_ID.TENCENT_TEXT_TO_3D_PRO,
    prompt,
    enablePbr: material === MATERIAL.PBR,
    geometryOnly: material === MATERIAL.GEOMETRY_ONLY,
    private: isPrivate,
    useCase: selectedUseCase,
    providerRunAttributes: {
      ...(targetPolycount != null && { faceCount: targetPolycount }),
      ...(polygonType != null && { polygonType }),
    },
  }
}
